import React from 'react';
import { UncontrolledTooltip as DefaultUncontrolledTooltip } from 'reactstrap';

export default function UncontrolledTooltip(props) {
    return <DefaultUncontrolledTooltip delay={0} {...props} />
}